import { AgGridColumnDef } from '@tassat/common-definitions';
import moment from 'moment';

import ApiConnectionCellRenderer from 'SharedComponents/cellRenderComponent/apiConnectionCellRenderer';

export interface IRowData {
    pcgNumber: number;
    modifiedDate: moment.Moment;
    modifiedBy: string;
}

export const cellHeight = 60;

export const connectionsColumnDefs: AgGridColumnDef[] = [
    {
        field: 'APIConnectionInfo',
        headerName: 'API Connections',
        cellRenderer: ApiConnectionCellRenderer,
        cellRendererParams: { cellHeight: cellHeight },
        menuTabs: [],
        flex: 1
    },
    {
        field: 'apiConnection.APIConnectionName',
        headerName: 'Connection Name',
        hide: true,
        suppressColumnsToolPanel: true,
        sort: 'asc'
    },
    {
        field: 'apiConnection.SourceId',
        headerName: 'Source ID',
        hide: true,
        suppressColumnsToolPanel: true
    }
];